export const projectsName = {
  firstName: 'Назва Проекту',

  secondName: 'Назва Проекту',
};

export const portfolioText =
  'Після того, як будинок отримав сертифікат завершеності від ради та схвалено вашим агентом, ви можете лягти на ретельно вибраний диван і милуватися своїм чудовим новим будинком. Період усунення дефектів, коли підрядник зобов’язаний усунути будь-які недоліки, зазвичай триває 12 місяців.';
